module.exports = "<svg width=\"14\" height=\"11\" viewBox=\"0 0 14 11\"><path d=\"M13.32 4.97L8.99.64C8.7.35 8.22.35 7.93.64s-.29.77 0 1.06l2.97 2.97H1.21a.749.749 0 1 0 0 1.5h9.85L7.93 9.3c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l4.33-4.33c.29-.29.29-.77 0-1.06z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/fill/fullArrowRight.svg
// module id = 537
// module chunks = 0